import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { AuthProvider } from '@ragu-components/ord-types';

const AuthProvidersList = React.lazy(async () => import('./AuthProvidersList'));

export const authProvidersResource: OrdResourceProps = {
  key: Resources.auth_providers,
  name: Resources.auth_providers,
  list: <AuthProvidersList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: AuthProvider): string => record.name,
};
